document.addEventListener("DOMContentLoaded", function(){
var swipercategoryv2 = new Swiper(".category__v2--maininner", {
  slidesPerView: 1,
  spaceBetween: 0,
  scrollbar: {
    el: ".swiper-scrollbar.categoryv",
  },
  navigation: {
    nextEl: ".swiper-button-next.vcategory",
    prevEl: ".swiper-button-prev.vcategory",
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 19,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 19,
    },
    1080: {
      slidesPerView: 5,
      spaceBetween: 19,
    },
  }
});
})